/** @jsx jsx */
import React from 'react';
import { Stack } from '@balance-web/stack';
import { CSSObject, jsx } from '@balance-web/core';
import { useTheme } from '@balance-web/theme';

const BAR_GAP = 6;

export type PasswordStrengthProps = {
  score?: 1 | 2 | 3 | 4 | 5;
};

export const PasswordStrength: React.FC<PasswordStrengthProps> = ({
  score,
}) => {
  const { palette } = useTheme();
  const defaultColor = palette.text['dim'];
  const scores = {
    1: palette.text['critical'],
    2: palette.text['critical'],
    3: palette.text['critical'],
    4: palette.text['critical'],
    5: palette.text['positive'],
  };

  const beforeAfterStyles = {
    boxSizing: 'border-box',
    position: 'absolute',
    content: '""',
    height: 'inherit',
    background: 'transparent',
    display: 'block',
    borderColor: palette.background.base,
    borderStyle: 'solid',
    borderWidth: `0 ${BAR_GAP} 0`,
    width: `calc(20% + ${BAR_GAP})`,
    zIndex: 10,
  } as const;

  const barStyles: CSSObject = {
    height: 'inherit',
    position: 'absolute',
    borderRadius: 'inherit',
    transition: `width 0.5s ease-in-out, background 0.25s`,
    background: `${score ? scores[score] : defaultColor}`,
    width: score ? `calc(20% * ${score})` : 0,
  };

  return (
    <Stack>
      <div
        css={{
          position: 'relative',
          height: 3,
          background: defaultColor,
          borderRadius: 2,
          '::before': {
            left: 'calc(20% - 3px)',
            ...beforeAfterStyles,
          },
          '::after': {
            right: 'calc(20% - 3px)',
            ...beforeAfterStyles,
          },
        }}
      >
        <div data-strength={score} css={barStyles} />
      </div>
    </Stack>
  );
};
